import { isOnPrem } from '@/utils/buildProfile';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';

const ENHANCE_SW_PATH = '/enhance-sw.js';

/**
 * Registers the Enhance preview sandbox's service worker in dev environments only.
 * The service worker file (public/enhance-sw.js) is also blocked via a
 * next.config.js beforeFiles rewrite that returns 404 in non-dev environments.
 *
 * This is the registration `enhance()` from `@enhance-eng/sandbox` performs, done
 * here so a failure is handled: the SDK injects an inline script that calls
 * `register()` with no catch, so a failed registration (the worker's
 * `importScripts` host, cdn.enhancelabs.ai, stopped resolving; or the 404 above)
 * became an unhandled rejection that opens Next's blocking dev overlay.
 */
export function initEnhance(): void {
  if (
    typeof window !== 'undefined' &&
    (window as Window & { __IS_E2E__?: boolean }).__IS_E2E__
  ) {
    return;
  }
  if (isOnPrem) return;
  const env = getEnvironment();
  if (env === ENV_NAME.DEV || env === ENV_NAME.AZURE_DEV) {
    navigator.serviceWorker?.register(ENHANCE_SW_PATH).catch(() => {
      // The preview sandbox is optional and nothing else depends on it.
    });
  }
}
